import { Link, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function DashboardLayout() {
  const { logout } = useAuth();

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      
      {/* Sidebar */}
      <div
        style={{
          width: "220px",
          background: "#222",
          color: "#fff",
          padding: "1rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between", // key change
        }}
      >
        {/* Top section */}
        <div>
          <h2>Admin</h2>

          <nav style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Link to="/dashboard">Home</Link>
            <Link to="/dashboard/mailboxes">Mailboxes</Link>
            <Link to="/dashboard/tenants">Tenants</Link>
          </nav>
        </div>

        {/* Bottom section */}
        <div>
          <button onClick={logout} style={{ width: "100%" }}>
            Logout
          </button>
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, padding: "2rem" }}>
        <Outlet />
      </div>
    </div>
  );
}